<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.geograficos.localidad.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave -->
                  <v-text-field v-if="localidad.clave" v-model="localidad.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Código -->
                  <v-text-field
                    v-model.trim="$v.localidad.codigo.$model"
                    :label="$t('view.geograficos.localidad.form.codigo.label')"
                    :error-messages="getFirstErrorDescription($v.localidad.codigo)"
                    maxlength="25"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[0-9]*$/.test(event.key);" />

                  <!-- nombre -->
                  <v-text-field
                    v-model.trim="$v.localidad.nombre.$model"
                    :label="$t('view.geograficos.localidad.form.nombre.label')"
                    :error-messages="getFirstErrorDescription($v.localidad.nombre)"
                    maxlength="150"
                    class="allcaps"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />

                  <!-- Provincia -->
                  <v-autocomplete
                    v-model.trim="$v.localidad.provincia.$model"
                    :label="$t('view.geograficos.localidad.form.provincia.label')"
                    :error-messages="getFirstErrorDescription($v.localidad.provincia)"
                    :items="view.elem.select.provincia.filteredList"
                    :disabled="view.action.submit.busy"
                    item-value="code"
                    item-text="name"
                    hide-selected
                    clearable
                    :no-data-text="$t('view.commons.nodata')"
                    @input="search = ''" />

                  <!-- Código Postal -->
                  <v-autocomplete
                    v-model.trim="$v.localidad.codigopostal.$model"
                    :label="$t('view.geograficos.localidad.form.codigopostal.label')"
                    :error-messages="getFirstErrorDescription($v.localidad.codigopostal) || getFirstErrorDescription($v.codigoPostal)"
                    :items="view.elem.select.codigopostal.filteredList"
                    :disabled="view.action.submit.busy"
                    :search-input.sync="codigoPostal"
                    hide-selected
                    hide-no-data
                    deletable-chips
                    clearable
                    multiple
                    small-chips
                    prepend-icon="fas fa-plus-circle"
                    @click:prepend="addCodigoPostal"
                    @keydown="addCodigoPostalKey" />

                  <!-- Estatus -->
                  <span class="label v-label mt-3">{{ $t("view.commons.status") }}</span>
                  <v-switch v-model="localidad.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-if="localidad.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="$userPermission.hasPermission('ROLE_MODIFICAR_GR')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="localidadTable" @editRow="load" @auditRow="audit"></data-table>
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal"></auditoria>
  </v-container>
</template>
<script>
import localidadStates from "@/views/geograficos/localidad/localidad-state"; /** *******************************/
import localidadAPI from "@/services/geograficos/localidad"; /** *******************************/
import DataTable from "@/views/geograficos/localidad/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const select = {
  provincia: {
    completeList: []
    , filteredList: []
  }
  , codigopostal: { filteredList: [] }
};

const action = { submit: { busy: false } };

export default {
  name: "LocalidadModulo"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      localidad: undefined
      , form: new Object()
      , codigoPostal: ""
      , view: {
        title: this.$t("view.geograficos.localidad.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new localidadStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.localidad);
        handleResponse(respuesta, this.$t("view.geograficos.localidad.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.geograficos.localidad.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await localidadAPI.get(clave);
        const { data: { results: { localidad } } } = response;
        this.form.$setState("editing", localidad);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.localidad.clave, dataDescripcion = this.localidad.nombre) {
      this.$refs.auditModal.loadAudit(clave, "TLocalidad", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , addCodigoPostalKey(key) {
      if (key && key.keyCode == 13) this.addCodigoPostal();
    }
    , addCodigoPostal() {
      if (this.codigoPostal && (this.codigoPostal.length > 15 || !/^-?\d+$/.test(this.codigoPostal))) {
        this.executeValidators();
      }
      if (this.codigoPostal && this.codigoPostal != "" && this.codigoPostal.length <= 15 && !this.localidad.codigopostal.includes(this.codigoPostal) && /^-?\d+$/.test(this.codigoPostal)) {
        this.localidad.codigopostal.push(this.codigoPostal);
        this.view.elem.select.codigopostal.filteredList.push(this.codigoPostal);
        this.codigoPostal = "";
      }
    }
  }
  , validations: {
    localidad: {
      codigo: { required }
      , nombre: { required, fixMigImp: fixMigImp() }
      , codigopostal: { required }
      , provincia: { required }
    }
    , codigoPostal: { maxLength: maxLength(15), numeric }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/geograficos/localidad/Localidad.vue